export const PaymentMethodType = {
  CASH: 0,
  BANK: 1,
};
